import React from 'react';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const points = ['Llegás a la sesión sin saber bien qué actividad probar hoy', 'Repetís siempre las mismas estrategias porque no sabés qué más hacer', 'Sentís que el niño no avanza y no podés explicarle bien a la familia por qué', 'Perdés horas del domingo planificando actividades para la semana', 'No tenés claro cuándo subir de nivel y cuándo sostener', 'La familia te pregunta qué pueden hacer en casa y no sabés qué decirles', 'Sentís que te falta criterio clínico para los casos más complejos', 'Cada caso de alimentación te genera más ansiedad que confianza'];
  return <section className="bg-surface py-16 px-4 border-t border-border" data-id="element-133">
      <div className="max-w-4xl mx-auto" data-id="element-134">
        <div className="text-center mb-10" data-id="element-135">
          <h2 className="text-3xl md:text-5xl font-bold text-ink mb-6 leading-tight font-serif" data-id="element-136">
            ¿Cuántas sesiones más vas a terminar sintiendo que no avanzaste
            nada?
          </h2>
          <p className="text-lg md:text-xl text-muted mb-4" data-id="element-137">
            Sos una profesional comprometida. Que estudió, que se capacitó, que
            quiere resultados reales para sus pacientes.
          </p>
          <p className="text-base md:text-lg text-ink/80 mb-6 font-medium" data-id="element-138">
            Pero nadie te enseñó que en la formación universitaria te dan la
            teoría y te dejan sola en el consultorio cuando el niño tira la
            comida al suelo, cuando la madre te mira esperando respuestas y
            cuando tu plan de sesión se derrumba a los 5 minutos de empezar.
          </p>
          <p className="text-lg md:text-xl font-bold text-primary" data-id="element-139">
            No es que sos mala terapeuta. Es que nunca te dieron el sistema.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-border shadow-sm" data-id="element-140">
          <h3 className="text-2xl font-bold text-ink mb-8 flex items-center font-serif" data-id="element-141">
            <XCircle className="w-8 h-8 text-urgency mr-3" data-id="element-142" />
            ¿Esto te suena familiar?
          </h3>

          <ul className="space-y-5" data-id="element-143">
            {points.map((point, i) => <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} key={i} className="flex items-start" data-id="element-144">
                <span className="text-urgency mr-4 text-xl mt-0.5" data-id="element-145">❌</span>
                <span className="text-base md:text-lg text-ink font-medium" data-id="element-146">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <div className="text-center mt-12" data-id="element-147">
          <p className="text-2xl md:text-3xl font-bold text-ink italic font-serif" data-id="element-148">
            ¿Y si esta fuera la última semana que lo pensás sin hacer nada?
          </p>
        </div>
      </div>
    </section>;
}